import { IconType } from 'components/atoms/Icon';
import { TBarChartValue } from 'components/atoms/SimpleBarChart/SimpleBarChart';
import Container from 'components/molecules/Container/Container';
import { HeadingWithIcon } from 'components/molecules/HeadingWithIcon';
import NavbarWithBackLink from 'components/molecules/NavbarWithBackLink/NavbarWithBackLink';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TSkillWithAnswer } from '../types';
import Assessment from './Assessment';

interface IRoleSpecificSoftSkillsAssessmentDesktop {
  headingTitle: string;
  headingIcon: IconType;
  headingDescription: string;
  onSubmit: (skillsWithAnswers: TSkillWithAnswer[]) => void;
  loading: boolean;
  initialSkillsWithAnswers: TSkillWithAnswer[];
  gradeBands: {
    proficiency: TBarChartValue;
  }[];
  hasMarkAllButton?: boolean;
  skillName: string;
  /** Back-link target — supplied by the hosting flow's navigation seam. */
  backUrl: string;
}

const RoleSpecificSoftSkillsAssessmentDesktop: FC<
  IRoleSpecificSoftSkillsAssessmentDesktop
> = ({
  headingDescription,
  headingIcon,
  headingTitle,
  initialSkillsWithAnswers,
  gradeBands,
  loading,
  hasMarkAllButton,
  skillName,
  onSubmit,
  backUrl,
}) => {
  const { t } = useTranslation();

  return (
    <Container className="role-specific-soft-skills-assessment">
      <NavbarWithBackLink
        to={backUrl}
        ariaLabel={t('assessment.returnToAllAssessmentActions')}
        label={t('assessment.actions')}
      />
      <div className="role-specific-soft-skills-assessment__content">
        <HeadingWithIcon
          title={headingTitle}
          icon={headingIcon}
          description={headingDescription}
          alt=""
        />
        <Assessment
          initialSkillsWithAnswers={initialSkillsWithAnswers}
          gradeBands={gradeBands}
          onSubmit={onSubmit}
          loading={loading}
          hasMarkAllButton={hasMarkAllButton}
          skillName={skillName}
        />
      </div>
    </Container>
  );
};

export default RoleSpecificSoftSkillsAssessmentDesktop;
